webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SAVE_PHFOOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_PHFOOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PH_ADD_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_GIS_FOOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_GIS_FOOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GIS_ADD_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_CARBO_FOOD_AFTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DELETE_CARBO_FOOD_AFTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CARBOAFTER_ADD_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_CARBO_FOOD_BEFORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_CARBO_FOOD_BEFORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CARBOBEFORE_ADD_WEIGHT; });
var SAVE_PHFOOD = 'SAVE_PHFOOD';
var DELETE_PHFOOD = 'DELETE_PHFOOD';
var PH_ADD_WEIGHT = 'PH_ADD_WEIGHT';

var SAVE_GIS_FOOD = 'SAVE_GIS_FOOD';
var DELETE_GIS_FOOD = 'DELETE_GIS_FOOD';
var GIS_ADD_WEIGHT = 'GIS_ADD_WEIGHT';

var SAVE_CARBO_FOOD_AFTER = 'SAVE_CARBO_FOOD_AFTER';
var DELETE_CARBO_FOOD_AFTER = 'DELETE_CARBO_FOOD_AFTER';
var CARBOAFTER_ADD_WEIGHT = 'CARBOAFTER_ADD_WEIGHT';

var SAVE_CARBO_FOOD_BEFORE = 'SAVE_CARBO_FOOD_BEFORE';
var DELETE_CARBO_FOOD_BEFORE = 'DELETE_CARBO_FOOD_BEFORE';
var CARBOBEFORE_ADD_WEIGHT = 'CARBOBEFORE_ADD_WEIGHT';

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {global.apiurl = 'https://etang.kingsha.com/api/wp/v2';
global.apiurl_foodcats = apiurl + '/sport_food_category?per_page=30&fields=id,name,parent&parent=0';
global.apiurl_foods = apiurl + '/sport_food?per_page=100&fields=id,title,sport_food_category,meta_box&sport_food_category=';
global.apiurl_motion_type = apiurl + '/sport_type?per_page=100&fields=id,title,meta_box';
global.apiurl_sugar_foodcats = apiurl + '/index_food_category?per_page=30&fields=id,name,parent&parent=0';
global.apiurl_sugar_foods = apiurl + '/index_food?per_page=100&fields=meta_box,title,id,index_food_category&index_food_category=';
global.food_thumb_api = "https://img.p.kingsha.com/etang/";
global.sport_thumb_api = "https://img.p.kingsha.com/etang/sports/";
global.sport_type_api = apiurl + "/sport_category?fields=id,name,parent&parent=";
global.jump_base = "https://etang.kingsha.com/weixin.php?op=";
global.jumpornot = false;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_head__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(75);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    var position = {
      x: 0,
      y: 0
    };
    if (to.path === '/') {
      position.y = +sessionStorage.getItem('scrollTop') || 0;
    }
    return position;
  }
}));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(76);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
    totalTime: 10,
    gisfoodlist: [],
    phfoodlist: [],
    carbofoodlist1: [],
    carbofoodlist2: [],
    foodweights: [],
    dataHeight: [],
    dataWeight: [],
    dataInsulin: []
};

for (var i = 0; i < 161; i++) {
    state.dataWeight[i] = {
        text: 40 + 0.5 * i + 'kg',
        value: 40 + 0.5 * i
    };
}
for (var i = 0; i < 56; i++) {
    state.dataHeight[i] = {
        text: 145 + 1 * i + 'CM',
        value: 145 + 1 * i
    };
}
for (var i = 0; i < 20; i++) {
    state.foodweights[i] = {
        text: 5 + 5 * i + 'g',
        value: 5 + 5 * i
    };
}
for (var i = 0; i < 51; i++) {
    state.dataInsulin[i] = {
        text: 10 + i
    };
}
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: state,
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
}));

/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(139),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },

  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) {
  window.Swiper = __webpack_require__(20);
  __webpack_require__(111);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function mount() {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    };
    this.options.notNextTick ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      swiperSlides: [],
      startVal: 0,
      theseparator: '',
      swiperOption: {
        autoplay: false,
        setWrapperSize: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        mousewheelControl: true,
        observeParents: true
      }
    };
  },

  computed: {
    swiper: function swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  head: {
    title: function title() {
      return {
        inner: '血糖指数',
        separator: ' ',
        complement: ' '
      };
    }
  },
  created: function created() {
    this.swiperSlides = this.$store.state.gisfoodlist;
  },

  methods: {
    gohome: function gohome() {
      this.$router.replace({ path: '/sugarindex' });
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_better_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);





/* harmony default export */ __webpack_exports__["default"] = ({
	components: { Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a },
	computed: {
		foodschosed: function foodschosed() {
			return this.$store.state.gisfoodlist;
		}
	},
	data: function data() {
		return {
			loading: true,
			finished: false,
			foodcats: [],
			foods: []
		};
	},

	head: {
		title: function title() {
			return {
				inner: '热量计算',
				separator: ' ',
				complement: ' '
			};
		}
	},
	created: function created() {
		var _this = this;

		this.axios.get(apiurl_sugar_foodcats).then(function (response) {
			var data1 = [];
			var len = response.data.length;

			var _loop = function _loop(i) {
				data1[i] = {
					text: response.data[i].name,
					value: response.data[i].id
				};

				_this.axios.get(apiurl_sugar_foods + response.data[i].id).then(function (responsefood) {
					var foodsresult = responsefood.data;
					var foods_len = responsefood.data.length;
					var foods_arr = [];
					for (var j = 0; j < foods_len; j++) {
						var codestr = foodsresult[j].meta_box.index_food_code;
						var thumburl = '';
						if (codestr) {
							thumburl = food_thumb_api + 'index/' + codestr + '.jpg!food';
						}
						foods_arr[j] = {
							text: foodsresult[j].title.rendered,
							value: foodsresult[j].id,
							foodthumb: thumburl,
							food_useable_percent: foodsresult[j].meta_box.index_food_index
						};
					}
					_this.foods[i] = foods_arr;
				});
			};

			for (var i = 0; i < len; i++) {
				_loop(i);
			}
			_this.foodcats = data1;
		});
	},

	methods: {
		poppicker: function poppicker() {
			var _this2 = this;

			var interv;
			interv = setInterval(function () {
				if (_this2.foods.length > 0) {
					clearInterval(interv);

					var data1 = _this2.foodcats;
					var data2 = _this2.foods[0];
					var picker = new __WEBPACK_IMPORTED_MODULE_0_better_picker___default.a({
						data: [data1, data2],
						selectedIndex: [0, 1],
						title: '选择食物'
					});
					var _that = _this2;
					picker.on('picker.change', function (index, selectedIndex) {
						if (index == 0) {
							var second = _that.foods[selectedIndex];
							picker.refillColumn(1, second);
						}
					});
					picker.on('picker.select', function (selectedVal, selectedIndex) {
						data2 = _that.foods[selectedIndex[0]];

						if (_that.foodschosed.length) {
							for (var i = 0; i < _that.foodschosed.length; i++) {
								if (_that.foodschosed[i].id == data2[selectedIndex[1]].value) {
									_that.removePicker();
									return false;
								}
							}
							var temp_arr = {
								id: data2[selectedIndex[1]].value,
								foodTitle: data2[selectedIndex[1]].text,
								foodThumb: data2[selectedIndex[1]].foodthumb,
								foodUseable: data2[selectedIndex[1]].food_useable_percent
							};
							_that.$store.dispatch('saveGisFood', temp_arr);
						} else {
							var temp_arr = {
								id: data2[selectedIndex[1]].value,
								foodTitle: data2[selectedIndex[1]].text,
								foodThumb: data2[selectedIndex[1]].foodthumb,
								foodUseable: data2[selectedIndex[1]].food_useable_percent
							};
							_that.$store.dispatch('saveGisFood', temp_arr);
						}

						_that.removePicker();
					});
					picker.on('picker.cancel', function () {
						_that.removePicker();
					});
					picker.on('picker.valuechange', function (selectedVal, selectedIndex) {});
					picker.show();
				}
			}, 50);
		},
		delfood: function delfood(idx) {
			this.$store.dispatch('deleteGisFood', idx);
		},
		calculate: function calculate() {

			if (!this.foodschosed.length) {
				var obj = {
					message: '请选择所吃食物',
					type: 'error',
					customCloseBtnText: '确定'
				};
				this.$refs.simplert.openSimplert(obj);
			} else {
				this.$router.replace({ path: '/gis' });
			}
		}
	}
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			imgUrl: '/static/topbanner2.png' };
	},

	head: {
		title: function title() {
			return {
				inner: '血糖生成指数',
				separator: ' ',
				complement: ' '
			};
		}
	},
	created: function created() {
		if (jumpornot) {
			if (localStorage.openid) {} else if (this.$route.query.openid) {
				localStorage.openid = this.$route.query.openid;
			} else {
				window.location.href = jump_base + 'index';
			}
		}
	}
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      unit: ''
    };
  },

  head: {
    title: function title() {
      return {
        inner: '餐前注射胰岛素',
        separator: ' ',
        complement: ' '
      };
    }
  },
  created: function created() {
    this.unit = this.$route.query.unit;
  },

  methods: {
    gohome: function gohome() {
      this.$router.replace({ path: '/carboindex' });
    }
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_better_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);





/* harmony default export */ __webpack_exports__["default"] = ({
	components: { Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a },
	computed: {
		foodschosed: function foodschosed() {
			return this.$store.state.carbofoodlist2;
		},
		foodweights: function foodweights() {
			return this.$store.state.foodweights;
		}
	},
	data: function data() {
		return {
			loading: true,
			finished: false,
			foodcats: [],
			foods: []
		};
	},

	head: {
		title: function title() {
			return {
				inner: '补打胰岛素',
				separator: ' ',
				complement: ' '
			};
		}
	},
	created: function created() {
		var _this = this;

		this.axios.get(apiurl_foodcats).then(function (response) {
			var data1 = [];
			var len = response.data.length;

			var _loop = function _loop(i) {
				data1[i] = {
					text: response.data[i].name,
					value: response.data[i].id
				};

				_this.axios.get(apiurl_foods + response.data[i].id).then(function (responsefood) {
					var foodsresult = responsefood.data;
					var foods_len = responsefood.data.length;
					var foods_arr = [];
					for (var j = 0; j < foods_len; j++) {
						var codestr = foodsresult[j].meta_box.sport_food_code;
						var thumburl = '';
						if (codestr) {
							for (var k = codestr.length; k < 4; k++) {
								codestr = '0' + codestr;
							}
							thumburl = food_thumb_api + '/sport/' + codestr + '.jpg!food';
						}
						foods_arr[j] = {
							text: foodsresult[j].title.rendered,
							value: foodsresult[j].id,
							food_thumb: thumburl,
							food_useable: foodsresult[j].meta_box.sport_food_index,
							food_drate: foodsresult[j].meta_box.sport_food_drate,
							food_fibre: foodsresult[j].meta_box.sport_food_fibre
						};
					}
					_this.foods[i] = foods_arr;
				});
			};

			for (var i = 0; i < len; i++) {
				_loop(i);
			}
			_this.foodcats = data1;
		});
	},

	methods: {
		poppicker: function poppicker() {
			var _this2 = this;

			var interv;
			interv = setInterval(function () {
				if (_this2.foods.length > 0) {
					clearInterval(interv);

					var data1 = _this2.foodcats;
					var data2 = _this2.foods[0];
					var data3 = _this2.foodweights;
					var picker = new __WEBPACK_IMPORTED_MODULE_0_better_picker___default.a({
						data: [data1, data2, data3],
						selectedIndex: [0, 1, 2],
						title: '选择食物'
					});
					var _that = _this2;
					picker.on('picker.change', function (index, selectedIndex) {
						if (index == 0) {
							var second = _that.foods[selectedIndex];
							picker.refillColumn(1, second);
						}
					});
					picker.on('picker.select', function (selectedVal, selectedIndex) {
						data2 = _that.foods[selectedIndex[0]];

						if (_that.foodschosed.length) {
							for (var i = 0; i < _that.foodschosed.length; i++) {
								if (_that.foodschosed[i].id == data2[selectedIndex[1]].value) {
									var objtemp = {
										obj_weight: data3[selectedIndex[2]].value,
										obj_index: i
									};
									_that.$store.dispatch('carboafterAddWeight', objtemp);
									_that.removePicker();
									return false;
								}
							}
							var temp_arr = {
								id: data2[selectedIndex[1]].value,
								foodTitle: data2[selectedIndex[1]].text,
								foodWeight: data3[selectedIndex[2]].value,
								foodThumb: data2[selectedIndex[1]].food_thumb,
								foodUseable: data2[selectedIndex[1]].food_useable,
								foodDrate: data2[selectedIndex[1]].food_drate,
								foodFibre: data2[selectedIndex[1]].food_fibre
							};
							_that.$store.dispatch('saveCarboFoodAfter', temp_arr);
						} else {
							var temp_arr = {
								id: data2[selectedIndex[1]].value,
								foodTitle: data2[selectedIndex[1]].text,
								foodWeight: data3[selectedIndex[2]].value,
								foodThumb: data2[selectedIndex[1]].food_thumb,
								foodUseable: data2[selectedIndex[1]].food_useable,
								foodDrate: data2[selectedIndex[1]].food_drate,
								foodFibre: data2[selectedIndex[1]].food_fibre
							};
							_that.$store.dispatch('saveCarboFoodAfter', temp_arr);
						}

						_that.removePicker();
					});
					picker.on('picker.cancel', function () {
						_that.removePicker();
					});
					picker.on('picker.valuechange', function (selectedVal, selectedIndex) {});
					picker.show();
					document.getElementsByClassName('picker')[0].className += ' three';
				}
			}, 50);
		},
		delfood: function delfood(idx) {
			this.$store.dispatch('deleteCarboFoodAfter', idx);
		},
		calculate: function calculate() {

			if (!this.foodschosed.length) {
				var obj = {
					message: '请选择所吃食物',
					type: 'error',
					customCloseBtnText: '确定'
				};
				this.$refs.simplert.openSimplert(obj);
			} else {
				var drate_total = 0;
				for (var i = 0; i < this.foodschosed.length; i++) {
					console.log(this.foodschosed[i]);
					drate_total += this.foodschosed[i].foodWeight * this.foodschosed[i].foodUseable * (this.foodschosed[i].foodDrate - this.foodschosed[i].foodFibre) / 100;
				}
				drate_total = Math.round(drate_total);
				this.$router.push({
					path: '/carboresult',
					query: { carbo_total: drate_total }
				});
			}
		}
	}
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_better_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);





/* harmony default export */ __webpack_exports__["default"] = ({
	components: { Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a },
	computed: {
		foodschosed: function foodschosed() {
			return this.$store.state.carbofoodlist1;
		},
		foodweights: function foodweights() {
			return this.$store.state.foodweights;
		}
	},
	data: function data() {
		return {
			loading: true,
			finished: false,
			foodcats: [],
			foods: []
		};
	},

	head: {
		title: function title() {
			return {
				inner: '餐前注射胰岛素',
				separator: ' ',
				complement: ' '
			};
		}
	},
	created: function created() {
		var _this = this;

		this.axios.get(apiurl_foodcats).then(function (response) {
			var data1 = [];
			var len = response.data.length;

			var _loop = function _loop(i) {
				data1[i] = {
					text: response.data[i].name,
					value: response.data[i].id
				};

				_this.axios.get(apiurl_foods + response.data[i].id).then(function (responsefood) {
					var foodsresult = responsefood.data;
					var foods_len = responsefood.data.length;
					var foods_arr = [];
					for (var j = 0; j < foods_len; j++) {
						var codestr = foodsresult[j].meta_box.sport_food_code;
						var thumburl = '';
						if (codestr) {
							for (var k = codestr.length; k < 4; k++) {
								codestr = '0' + codestr;
							}
							thumburl = food_thumb_api + '/sport/' + codestr + '.jpg!food';
						}
						foods_arr[j] = {
							text: foodsresult[j].title.rendered,
							value: foodsresult[j].id,
							food_thumb: thumburl,
							food_useable: foodsresult[j].meta_box.sport_food_index,
							food_drate: foodsresult[j].meta_box.sport_food_drate,
							food_fibre: foodsresult[j].meta_box.sport_food_fibre
						};
					}
					_this.foods[i] = foods_arr;
				});
			};

			for (var i = 0; i < len; i++) {
				_loop(i);
			}
			_this.foodcats = data1;
		});
	},

	methods: {
		poppicker: function poppicker() {
			var _this2 = this;

			var interv;
			interv = setInterval(function () {
				if (_this2.foods.length > 0) {
					clearInterval(interv);

					var data1 = _this2.foodcats;
					var data2 = _this2.foods[0];
					var data3 = _this2.foodweights;
					var picker = new __WEBPACK_IMPORTED_MODULE_0_better_picker___default.a({
						data: [data1, data2, data3],
						selectedIndex: [0, 1, 2],
						title: '选择食物'
					});
					var _that = _this2;
					picker.on('picker.change', function (index, selectedIndex) {
						if (index == 0) {
							var second = _that.foods[selectedIndex];
							picker.refillColumn(1, second);
						}
					});
					picker.on('picker.select', function (selectedVal, selectedIndex) {
						data2 = _that.foods[selectedIndex[0]];

						if (_that.foodschosed.length) {
							for (var i = 0; i < _that.foodschosed.length; i++) {
								if (_that.foodschosed[i].id == data2[selectedIndex[1]].value) {
									var objtemp = {
										obj_weight: data3[selectedIndex[2]].value,
										obj_index: i
									};
									_that.$store.dispatch('carbobeforeAddWeight', objtemp);
									_that.removePicker();
									return false;
								}
							}
							var temp_arr = {
								id: data2[selectedIndex[1]].value,
								foodTitle: data2[selectedIndex[1]].text,
								foodWeight: data3[selectedIndex[2]].value,
								foodThumb: data2[selectedIndex[1]].food_thumb,
								foodUseable: data2[selectedIndex[1]].food_useable,
								foodDrate: data2[selectedIndex[1]].food_drate,
								foodFibre: data2[selectedIndex[1]].food_fibre
							};
							_that.$store.dispatch('saveCarboFoodBefore', temp_arr);
						} else {
							var temp_arr = {
								id: data2[selectedIndex[1]].value,
								foodTitle: data2[selectedIndex[1]].text,
								foodWeight: data3[selectedIndex[2]].value,
								foodThumb: data2[selectedIndex[1]].food_thumb,
								foodUseable: data2[selectedIndex[1]].food_useable,
								foodDrate: data2[selectedIndex[1]].food_drate,
								foodFibre: data2[selectedIndex[1]].food_fibre
							};
							_that.$store.dispatch('saveCarboFoodBefore', temp_arr);
						}

						_that.removePicker();
					});
					picker.on('picker.valuechange', function (selectedVal, selectedIndex) {});
					picker.on('picker.cancel', function () {
						_that.removePicker();
					});
					picker.show();
					document.getElementsByClassName('picker')[0].className += ' three';
				}
			}, 50);
		},
		delfood: function delfood(idx) {
			this.$store.dispatch('deleteCarboFoodAfter', idx);
		},
		calculate: function calculate() {

			if (!this.foodschosed.length) {
				var obj = {
					message: '请选择所吃食物',
					type: 'error',
					customCloseBtnText: '确定'
				};
				this.$refs.simplert.openSimplert(obj);
			} else {
				var drate_total = 0;
				for (var i = 0; i < this.foodschosed.length; i++) {
					drate_total += this.foodschosed[i].foodWeight * this.foodschosed[i].foodUseable * (this.foodschosed[i].foodDrate - this.foodschosed[i].foodFibre) / 100;
				}
				drate_total = Math.round(drate_total);
				console.log(drate_total);
				this.$router.push({
					path: '/carboresult1',
					query: { carbo_total: drate_total }
				});
			}
		}
	}
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			imgUrl: '/static/topbanner4.png' };
	},

	head: {
		title: function title() {
			return {
				inner: '碳水化合物',
				separator: ' ',
				complement: ' '
			};
		}
	},
	created: function created() {
		if (jumpornot) {
			if (localStorage.openid) {} else if (this.$route.query.openid) {
				localStorage.openid = this.$route.query.openid;
			} else {
				window.location.href = jump_base + 'drate';
			}
		}
	}
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_count_to__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { countTo: __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default.a },
  data: function data() {
    return {
      startVal: 0,
      endVal: 22.2,
      theseparator: '',
      cover: '/static/zhushe.png',
      unit: 0
    };
  },

  head: {
    title: function title() {
      return {
        inner: '补打胰岛素',
        separator: ' ',
        complement: ' '
      };
    }
  },
  created: function created() {
    this.endVal = parseInt(this.$route.query.carbo_total);
    this.unit = parseInt(this.endVal / 15);
  },

  methods: {
    gohome: function gohome() {
      this.$router.replace({ path: '/carboindex' });
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_better_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_count_to__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_count_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: { countTo: __WEBPACK_IMPORTED_MODULE_1_vue_count_to___default.a, Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a },
    computed: {
        dataInsulin: function dataInsulin() {
            return this.$store.state.dataInsulin;
        }
    },
    data: function data() {
        return {
            startVal: 0,
            endVal: 0,
            theseparator: '',
            show_error: false,
            show_error1: false,
            dataInsulinType: [{
                text: '速效胰岛素',
                value: '速效'
            }, {
                text: '短效胰岛素',
                value: '短效'
            }],
            show: false,
            show1: false,
            data_canqian: '',
            data_canhou: '',
            data_total: '',
            data_zhushe: ''
        };
    },

    head: {
        title: function title() {
            return {
                inner: '餐前注射胰岛素',
                separator: ' ',
                complement: ' '
            };
        }
    },
    created: function created() {
        this.endVal = parseInt(this.$route.query.carbo_total);
    },

    methods: {
        hidepop: function hidepop() {
            this.show = false;
        },
        showpop: function showpop() {
            this.show = true;
            this.$nextTick(function () {
                document.getElementById("typevalue").focus();
            });
        },
        hidepop1: function hidepop1() {
            this.show1 = false;
        },
        showpop1: function showpop1() {
            this.show1 = true;
            this.$nextTick(function () {
                document.getElementById("typevalue1").focus();
            });
        },
        selectInsulin: function selectInsulin() {
            var picker1 = new __WEBPACK_IMPORTED_MODULE_0_better_picker___default.a({
                data: [this.dataInsulin],
                selectedIndex: [5],
                title: '选择一日胰岛素总用量'
            });
            var _that = this;
            picker1.on('picker.select', function (selectedVal, selectedIndex) {
                _that.data_total = _that.dataInsulin[selectedIndex[0]].text;
            });

            picker1.show();
        },
        selectType: function selectType() {
            var picker2 = new __WEBPACK_IMPORTED_MODULE_0_better_picker___default.a({
                data: [this.dataInsulinType],
                selectedIndex: [0],
                title: '选择胰岛素类别'
            });
            var _that = this;
            picker2.on('picker.select', function (selectedVal, selectedIndex) {
                _that.data_zhushe = _that.dataInsulinType[selectedIndex[0]].value;
            });
            picker2.show();
        },
        savedata: function savedata() {
            var result = document.getElementById('typevalue').value;
            if (result != '') {
                var regx = /^\d+$|^\d+\.\d{0,1}$/gi;
                var flag = regx.test(result);
                if (flag && result >= 4.4 && result <= 25) {
                    if (result.split('.').length > 1 && result.split('.')[1].length != 1) {
                        this.show_error = true;
                    } else {
                        this.show_error = false;
                        this.show = false;
                        this.data_canqian = result;
                    }
                } else {
                    this.show_error = true;
                }
            } else {
                this.show_error = true;
            }
            if (this.show_error) {
                document.getElementById('typevalue').value = '';
                document.getElementById('typevalue').focus();
            }
        },
        savedata1: function savedata1() {
            var result = document.getElementById('typevalue1').value;
            if (result != '') {
                var regx = /^\d+$|^\d+\.\d{0,1}$/gi;
                var flag = regx.test(result);
                if (flag && result >= 4.4 && result <= 15) {
                    if (result.split('.').length > 1 && result.split('.')[1].length != 1) {
                        this.show_error1 = true;
                    } else {
                        this.show_error1 = false;
                        this.show1 = false;
                        this.data_canhou = result;
                    }
                } else {
                    this.show_error1 = true;
                }
            } else {
                this.show_error1 = true;
            }
            if (this.show_error1) {
                document.getElementById('typevalue1').value = '';
                document.getElementById('typevalue1').focus();
            }
        },
        goresult: function goresult() {
            if (!this.data_canqian) {
                var obj = {
                    message: '请填写餐前血糖值',
                    type: 'error',
                    customCloseBtnText: '确定'
                };
                this.$refs.simplert.openSimplert(obj);
                return false;
            }
            if (!this.data_canhou) {
                var _obj = {
                    message: '请填写餐后目标值',
                    type: 'error',
                    customCloseBtnText: '确定'
                };
                this.$refs.simplert.openSimplert(_obj);
                return false;
            }
            if (!this.data_total) {
                var _obj2 = {
                    message: '请填写一日胰岛素总用量',
                    type: 'error',
                    customCloseBtnText: '确定'
                };
                this.$refs.simplert.openSimplert(_obj2);
                return false;
            }
            if (!this.data_zhushe) {
                var _obj3 = {
                    message: '请填写使用胰岛素类别',
                    type: 'error',
                    customCloseBtnText: '确定'
                };
                this.$refs.simplert.openSimplert(_obj3);
                return false;
            }
            var type_num = 1800;
            if (this.data_zhushe == '短效') {
                type_num = 1500;
            }
            var result = this.endVal / 15 + (this.data_canqian - this.data_canhou) / (type_num / this.data_total / 18);
            console.log(result);
            result = parseInt(result);
            this.$router.replace({
                path: '/carbofinal',
                query: { unit: result }
            });
        }
    }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			imgUrl: '/static/topbanner3.png' };
	},

	head: {
		title: function title() {
			return {
				inner: '一日所需能量',
				separator: ' ',
				complement: ' '
			};
		}
	},
	created: function created() {
		if (jumpornot) {
			if (localStorage.openid) {} else if (this.$route.query.openid) {
				localStorage.openid = this.$route.query.openid;
			} else {
				window.location.href = jump_base + 'power';
			}
		}
	}
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_count_to__);




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		countTo: __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default.a
	},
	data: function data() {
		return {
			startVal: 0,
			endVal: parseInt(this.$route.query.energy_required),
			theseparator: '',
			a: 0,
			b: 0
		};
	},

	head: {
		title: function title() {
			return {
				inner: '一日所需能量',
				separator: ' ',
				complement: ' '
			};
		}
	},
	created: function created() {
		this.a = this.endVal / 5;
		this.b = Math.round(this.endVal / 3);
	}
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_count_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_better_picker__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_better_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_better_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: { countTo: __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default.a, Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a },
    computed: {
        dataHeight: function dataHeight() {
            return this.$store.state.dataHeight;
        },
        dataWeight: function dataWeight() {
            return this.$store.state.dataWeight;
        }
    },
    data: function data() {
        return {
            defaultWeight: 0,
            defaultMotion: '',
            defaultHeight: '',
            motionNum: 0,
            needed: 0,
            sportType: [],
            sportSubType: []
        };
    },

    head: {
        title: function title() {
            return {
                inner: '一日所需能量',
                separator: ' ',
                complement: ' '
            };
        }
    },
    created: function created() {
        var _this = this;

        this.axios.get(sport_type_api + '0').then(function (response) {
            var data_motion = [];
            var len = response.data.length;

            var _loop = function _loop(i) {
                data_motion[i] = {
                    text: response.data[i].name,
                    value: response.data[i].id
                };

                _this.axios.get(sport_type_api + response.data[i].id).then(function (responsefood) {
                    var subtypes = responsefood.data;
                    var sublen = responsefood.data.length;
                    var subTypeArr = [];
                    for (var j = 0; j < sublen; j++) {
                        subTypeArr[j] = {
                            text: subtypes[j].name,
                            value: subtypes[j].id
                        };
                    }
                    if (subTypeArr.length == 0) {
                        subTypeArr[0] = {
                            text: '卧床休息',
                            value: '卧床休息'
                        };
                    }
                    _this.sportSubType[i] = subTypeArr;
                });
            };

            for (var i = 0; i < len; i++) {
                _loop(i);
            }
            _this.sportType = data_motion;
        });
    },

    methods: {
        selectWeight: function selectWeight() {
            var picker1 = new __WEBPACK_IMPORTED_MODULE_1_better_picker___default.a({
                data: [this.dataWeight],
                selectedIndex: [0],
                title: '选择体重'
            });
            var _that = this;
            picker1.on('picker.select', function (selectedVal, selectedIndex) {
                _that.defaultWeight = _that.dataWeight[selectedIndex[0]].value;
            });
            picker1.show();
        },
        selectHeight: function selectHeight() {
            var picker3 = new __WEBPACK_IMPORTED_MODULE_1_better_picker___default.a({
                data: [this.dataHeight],
                selectedIndex: [0],
                title: '选择身高'
            });
            var _that = this;
            picker3.on('picker.select', function (selectedVal, selectedIndex) {
                _that.defaultHeight = _that.dataHeight[selectedIndex[0]].value;
            });
            picker3.show();
        },
        selectMotion: function selectMotion() {
            var _this2 = this;

            var interv;
            interv = setInterval(function () {
                if (_this2.sportSubType.length > 1) {
                    clearInterval(interv);

                    var picker2 = new __WEBPACK_IMPORTED_MODULE_1_better_picker___default.a({
                        data: [_this2.sportType, _this2.sportSubType[0]],
                        selectedIndex: [0, 1],
                        title: '选择活动强度'
                    });
                    var _that = _this2;
                    picker2.on('picker.change', function (index, selectedIndex) {
                        if (index == 0) {
                            var second = _that.sportSubType[selectedIndex];
                            picker2.refillColumn(1, second);
                        }
                    });
                    picker2.on('picker.select', function (selectedVal, selectedIndex) {
                        _that.defaultMotion = _that.sportType[selectedIndex[0]].text;
                        switch (_that.defaultMotion) {
                            case '卧床休息':
                                _that.motionNum = 0;
                                break;
                            case '轻体力劳动':
                                _that.motionNum = 1;
                                break;
                            case '中体力劳动':
                                _that.motionNum = 2;
                                break;
                            case '重体力劳动':
                                _that.motionNum = 3;
                                break;
                        }
                    });
                    picker2.show();
                }
            }, 50);
        },
        goresult: function goresult() {
            if (!this.defaultHeight) {
                var obj = {
                    message: '请选择身高',
                    type: 'error',
                    customCloseBtnText: '确定'
                };
                this.$refs.simplert.openSimplert(obj);
                return false;
            }
            if (!this.defaultWeight) {
                var _obj = {
                    message: '请选择体重',
                    type: 'error',
                    customCloseBtnText: '确定'
                };
                this.$refs.simplert.openSimplert(_obj);
                return false;
            }
            if (!this.defaultMotion) {
                var _obj2 = {
                    message: '请选择活动强度',
                    type: 'error',
                    customCloseBtnText: '确定'
                };
                this.$refs.simplert.openSimplert(_obj2);
                return false;
            }
            var ideal_weight = this.defaultHeight - 105;
            var float_weight = ideal_weight * 10 / 100;
            var your_figure = 1;
            if (this.defaultWeight > ideal_weight + float_weight * 2) {
                your_figure = 2;
            } else if (this.defaultWeight < ideal_weight - float_weight * 2) {
                your_figure = 0;
            }
            switch (your_figure) {
                case 0:
                    if (this.motionNum == 0) {
                        var enl = this.defaultWeight * 20;
                        var enr = this.defaultWeight * 25;
                        this.needed = (enl + enr) / 2;
                    } else if (this.motionNum == 1) {
                        this.needed = this.defaultWeight * 35;
                    } else if (this.motionNum == 2) {
                        this.needed = this.defaultWeight * 40;
                    } else if (this.motionNum == 3) {
                        var enl = this.defaultWeight * 40;
                        var enr = this.defaultWeight * 45;
                        this.needed = (enl + enr) / 2;
                    }
                    break;
                case 1:
                    if (this.motionNum == 0) {
                        var enl = this.defaultWeight * 10;
                        var enr = this.defaultWeight * 20;
                        this.needed = (enl + enr) / 2;
                    } else if (this.motionNum == 1) {
                        this.needed = this.defaultWeight * 30;
                    } else if (this.motionNum == 2) {
                        this.needed = this.defaultWeight * 35;
                    } else if (this.motionNum == 3) {
                        this.needed = this.defaultWeight * 40;
                    }
                    break;
                case 2:
                    if (this.motionNum == 0) {
                        this.needed = this.defaultWeight * 15;
                    } else if (this.motionNum == 1) {
                        var enl = this.defaultWeight * 20;
                        var enr = this.defaultWeight * 25;
                        this.needed = (enl + enr) / 2;
                    } else if (this.motionNum == 2) {
                        this.needed = this.defaultWeight * 30;
                    } else if (this.motionNum == 3) {
                        this.needed = this.defaultWeight * 35;
                    }
                    break;
            }
            this.needed = Math.round(this.needed / 100) * 100;
            this.$router.replace({
                path: '/dayneedresult',
                query: { energy_required: this.needed }
            });
        }
    }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_better_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);





/* harmony default export */ __webpack_exports__["default"] = ({
	components: { Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a },
	computed: {
		foodschosed: function foodschosed() {
			return this.$store.state.phfoodlist;
		},
		foodweights: function foodweights() {
			return this.$store.state.foodweights;
		}
	},
	data: function data() {
		return {
			loading: true,
			finished: false,
			foodcats: [],
			foods: [],
			title: '热量计算'
		};
	},

	head: {
		title: function title() {
			return {
				inner: this.title,
				separator: ' ',
				complement: ' '
			};
		}
	},
	created: function created() {
		var _this = this;

		this.axios.get(apiurl_foodcats).then(function (response) {
			var data1 = [];
			var len = response.data.length;

			var _loop = function _loop(i) {
				data1[i] = {
					text: response.data[i].name,
					value: response.data[i].id
				};

				_this.axios.get(apiurl_foods + response.data[i].id).then(function (responsefood) {
					var foodsresult = responsefood.data;

					var foods_len = responsefood.data.length;
					var foods_arr = [];
					for (var j = 0; j < foods_len; j++) {
						var codestr = foodsresult[j].meta_box.sport_food_code;
						var thumburl = '';
						if (codestr) {
							for (var k = codestr.length; k < 4; k++) {
								codestr = '0' + codestr;
							}
							thumburl = food_thumb_api + 'sport/' + codestr + '.jpg!food';
						}

						foods_arr[j] = {
							text: foodsresult[j].title.rendered,
							value: foodsresult[j].id,
							foodthumb: thumburl,
							food_useable_percent: foodsresult[j].meta_box.sport_food_index,
							food_calorie: foodsresult[j].meta_box.sport_food_calorie
						};
					}
					_this.foods[i] = foods_arr;
				});
			};

			for (var i = 0; i < len; i++) {
				_loop(i);
			}
			_this.foodcats = data1;
		});
	},

	methods: {
		poppicker: function poppicker() {
			var _this2 = this;

			var interv;
			interv = setInterval(function () {
				if (_this2.foods.length > 0) {
					clearInterval(interv);

					var data1 = _this2.foodcats;
					var data2 = _this2.foods[0];
					var data3 = _this2.foodweights;
					var picker = new __WEBPACK_IMPORTED_MODULE_0_better_picker___default.a({
						data: [data1, data2, data3],
						selectedIndex: [0, 1, 2],
						title: '选择食物'
					});
					var _that = _this2;
					picker.on('picker.change', function (index, selectedIndex) {
						if (index == 0) {
							var second = _that.foods[selectedIndex];
							picker.refillColumn(1, second);
						}
					});
					picker.on('picker.select', function (selectedVal, selectedIndex) {
						data2 = _that.foods[selectedIndex[0]];
						if (_that.foodschosed.length) {
							for (var i = 0; i < _that.foodschosed.length; i++) {
								if (_that.foodschosed[i].id == data2[selectedIndex[1]].value) {
									var objtemp = {
										obj_weight: data3[selectedIndex[2]].value,
										obj_index: i
									};
									_that.$store.dispatch('phAddWeight', objtemp);
									_that.removePicker();
									return false;
								}
							}
							var temp_arr = {
								id: data2[selectedIndex[1]].value,
								foodTitle: data2[selectedIndex[1]].text,
								foodWeight: data3[selectedIndex[2]].value,
								foodThumb: data2[selectedIndex[1]].foodthumb,
								foodUseable: data2[selectedIndex[1]].food_useable_percent,
								foodCalorie: data2[selectedIndex[1]].food_calorie
							};
							_that.$store.dispatch('savePhfood', temp_arr);
						} else {
							var temp_arr = {
								id: data2[selectedIndex[1]].value,
								foodTitle: data2[selectedIndex[1]].text,
								foodWeight: data3[selectedIndex[2]].value,
								foodThumb: data2[selectedIndex[1]].foodthumb,
								foodUseable: data2[selectedIndex[1]].food_useable_percent,
								foodCalorie: data2[selectedIndex[1]].food_calorie
							};
							_that.$store.dispatch('savePhfood', temp_arr);
						}
						_that.removePicker();
					});
					picker.on('picker.cancel', function () {
						_that.removePicker();
					});
					picker.on('picker.valuechange', function (selectedVal, selectedIndex) {});
					picker.show();
					document.getElementsByClassName('picker')[0].className += ' three';
				}
			}, 50);
		},
		delfood: function delfood(idx) {
			this.$store.dispatch('deletePhfood', idx);
		},
		calculate: function calculate() {

			if (!this.foodschosed.length) {
				var obj = {
					message: '请选择所吃食物',
					type: 'error',
					customCloseBtnText: '确定'
				};
				this.$refs.simplert.openSimplert(obj);
			} else {
				this.$router.push({ path: '/chosemotion' });
			}
		}
	}
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_count_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_better_picker__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_better_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_better_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { countTo: __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default.a, Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a },
  computed: {
    endVal: function endVal() {
      var phflist = this.$store.state.phfoodlist;
      var lens = phflist.length;
      var result = 0;
      for (var i = 0; i < lens; i++) {
        result += phflist[i].foodWeight * phflist[i].foodUseable / 100 * (phflist[i].foodCalorie / 100);
      }
      result = Math.round(result);
      return result;
    },
    dataWeight: function dataWeight() {
      return this.$store.state.dataWeight;
    }
  },
  data: function data() {
    return {
      startVal: 0,
      theseparator: '',
      defaultWeight: 0,
      defaultMotion: '',
      foodmet: 0,
      sport_cover: '',
      dataMotion: [],
      title: '热量结果'
    };
  },

  head: {
    title: function title() {
      return {
        inner: this.title,
        separator: ' ',
        complement: ' '
      };
    }
  },
  created: function created() {
    var _this = this;

    this.axios.get(apiurl_motion_type).then(function (response) {
      var data_motion_arr = [];
      var len = response.data.length;
      for (var i = 0; i < len; i++) {
        data_motion_arr[i] = {
          text: response.data[i].title.rendered,
          value: response.data[i].id,
          cover: sport_thumb_api + response.data[i].id + '.jpg',
          foodmet: response.data[i].meta_box.sport_type_met
        };
      }
      _this.dataMotion = data_motion_arr;
    });
  },

  methods: {
    selectWeight: function selectWeight() {
      var picker1 = new __WEBPACK_IMPORTED_MODULE_1_better_picker___default.a({
        data: [this.dataWeight],
        selectedIndex: [0],
        title: '选择体重'
      });
      var _that = this;
      picker1.on('picker.select', function (selectedVal, selectedIndex) {
        _that.defaultWeight = _that.dataWeight[selectedIndex[0]].value;
        _that.removePicker();
      });
      picker1.on('picker.cancel', function () {
        _that.removePicker();
      });
      picker1.show();
    },
    selectMotion: function selectMotion() {
      var picker2 = new __WEBPACK_IMPORTED_MODULE_1_better_picker___default.a({
        data: [this.dataMotion],
        selectedIndex: [0],
        title: '选择运动'
      });
      var _that = this;
      picker2.on('picker.select', function (selectedVal, selectedIndex) {
        _that.defaultMotion = _that.dataMotion[selectedIndex[0]].text;
        _that.foodmet = _that.dataMotion[selectedIndex[0]].foodmet;
        _that.sport_cover = _that.dataMotion[selectedIndex[0]].cover;
        _that.removePicker();
      });
      picker2.on('picker.cancel', function () {
        _that.removePicker();
      });
      picker2.show();
    },
    goresult: function goresult() {
      if (!this.defaultWeight) {
        var obj = {
          message: '请选择体重',
          type: 'error',
          customCloseBtnText: '确定'
        };
        this.$refs.simplert.openSimplert(obj);
        return false;
      }
      if (!this.foodmet) {
        var _obj = {
          message: '请选择运动',
          type: 'error',
          customCloseBtnText: '确定'
        };
        this.$refs.simplert.openSimplert(_obj);
        return false;
      }
      var result;
      result = this.endVal / (this.foodmet * this.defaultWeight / 60);
      this.$router.replace({
        path: '/result',
        query: {
          totaltime: Math.round(result),
          totalenergy: this.endVal,
          sportcover: this.sport_cover,
          thetitle: this.defaultMotion
        }
      });
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			imgUrl: '/static/topbanner1.png',
			title: '吃动两平衡'
		};
	},

	head: {
		title: function title() {
			return {
				inner: this.title,
				separator: ' ',
				complement: ' '
			};
		}
	},
	created: function created() {
		if (jumpornot) {
			if (localStorage.openid) {} else if (this.$route.query.openid) {
				localStorage.openid = this.$route.query.openid;
			} else {
				window.location.href = jump_base + 'sport';
			}
		}
	}
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_count_to__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { countTo: __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default.a },
  data: function data() {
    return {
      startVal: 0,
      endVal: 0,
      theseparator: '',
      hour: 0,
      min: 0,
      cover: ''
    };
  },

  head: {
    title: function title() {
      return {
        inner: this.$route.query.thetitle,
        separator: ' ',
        complement: ' '
      };
    }
  },
  created: function created() {
    this.cover = this.$route.query.sportcover;
    this.endVal = parseInt(this.$route.query.totalenergy);
    var thetime = parseInt(this.$route.query.totaltime);
    if (thetime >= 60) {
      if (thetime % 60 == 0) {
        this.hour = thetime / 60;
      } else {
        var theresult = (thetime / 60).toFixed(2);
        this.hour = parseInt(theresult);
        this.min = parseInt((theresult - this.hour).toFixed(2) * 60);
      }
    } else {
      this.min = thetime;
    }
  },

  methods: {
    gohome: function gohome() {
      this.$router.replace({ path: '/' });
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lazyload__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_global__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__config_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_scss_style_css__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_scss_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_assets_scss_style_css__);











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_lazyload___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_4_axios___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.removePicker = function () {
  var elem = document.getElementsByClassName('picker');
  var _parentElement = elem[0].parentNode;
  _parentElement.removeChild(elem[0]);
};
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_2__App___default.a)).$mount('#app');

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_chosefood_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_chosefood_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_chosefood_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_chosemotion_vue__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_chosemotion_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_chosemotion_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_result_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_result_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_result_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blood_sugar_sugarindex_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blood_sugar_sugarindex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__blood_sugar_sugarindex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blood_sugar_selectfood_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blood_sugar_selectfood_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__blood_sugar_selectfood_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blood_sugar_gis_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blood_sugar_gis_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__blood_sugar_gis_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dayneed_dayneedindex_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dayneed_dayneedindex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__dayneed_dayneedindex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dayneed_fillform_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dayneed_fillform_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__dayneed_fillform_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dayneed_dayneedresult_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dayneed_dayneedresult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__dayneed_dayneedresult_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__carbohydrate_carboindex_vue__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__carbohydrate_carboindex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__carbohydrate_carboindex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__carbohydrate_carbofood_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__carbohydrate_carbofood_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__carbohydrate_carbofood_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__carbohydrate_carbofood1_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__carbohydrate_carbofood1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__carbohydrate_carbofood1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__carbohydrate_carboresult_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__carbohydrate_carboresult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__carbohydrate_carboresult_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__carbohydrate_carboresult1_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__carbohydrate_carboresult1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__carbohydrate_carboresult1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__carbohydrate_carbofinal_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__carbohydrate_carbofinal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__carbohydrate_carbofinal_vue__);




















/* harmony default export */ __webpack_exports__["a"] = ([{
	path: '/index',
	component: __WEBPACK_IMPORTED_MODULE_0__pages_index_vue___default.a,
	name: 'index'
}, {
	path: '/',
	component: __WEBPACK_IMPORTED_MODULE_0__pages_index_vue___default.a
}, {
	path: '/chosefood',
	component: __WEBPACK_IMPORTED_MODULE_1__pages_chosefood_vue___default.a
}, {
	path: '/chosemotion',
	component: __WEBPACK_IMPORTED_MODULE_2__pages_chosemotion_vue___default.a
}, {
	path: '/result',
	component: __WEBPACK_IMPORTED_MODULE_3__pages_result_vue___default.a
}, {
	path: '/sugarindex',
	component: __WEBPACK_IMPORTED_MODULE_4__blood_sugar_sugarindex_vue___default.a
}, {
	path: '/sugarfood',
	component: __WEBPACK_IMPORTED_MODULE_5__blood_sugar_selectfood_vue___default.a
}, {
	path: '/gis',
	component: __WEBPACK_IMPORTED_MODULE_6__blood_sugar_gis_vue___default.a
}, {
	path: '/dayneedindex',
	component: __WEBPACK_IMPORTED_MODULE_7__dayneed_dayneedindex_vue___default.a
}, {
	path: '/fillform',
	component: __WEBPACK_IMPORTED_MODULE_8__dayneed_fillform_vue___default.a
}, {
	path: '/dayneedresult',
	component: __WEBPACK_IMPORTED_MODULE_9__dayneed_dayneedresult_vue___default.a
}, {
	path: '/carboindex',
	component: __WEBPACK_IMPORTED_MODULE_10__carbohydrate_carboindex_vue___default.a
}, {
	path: '/carbofood',
	component: __WEBPACK_IMPORTED_MODULE_11__carbohydrate_carbofood_vue___default.a
}, {
	path: '/carbofood1',
	component: __WEBPACK_IMPORTED_MODULE_12__carbohydrate_carbofood1_vue___default.a
}, {
	path: '/carboresult',
	component: __WEBPACK_IMPORTED_MODULE_13__carbohydrate_carboresult_vue___default.a
}, {
	path: '/carboresult1',
	component: __WEBPACK_IMPORTED_MODULE_14__carbohydrate_carboresult1_vue___default.a
}, {
	path: '/carbofinal',
	component: __WEBPACK_IMPORTED_MODULE_15__carbohydrate_carbofinal_vue___default.a
}]);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = ({
  savePhfood: function savePhfood(_ref, plan) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* SAVE_PHFOOD */], plan);
  },
  deletePhfood: function deletePhfood(_ref2, plan) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* DELETE_PHFOOD */], plan);
  },
  phAddWeight: function phAddWeight(_ref3, objadd) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* PH_ADD_WEIGHT */], objadd);
  },
  saveGisFood: function saveGisFood(_ref4, plan) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SAVE_GIS_FOOD */], plan);
  },
  deleteGisFood: function deleteGisFood(_ref5, plan) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* DELETE_GIS_FOOD */], plan);
  },
  gisAddWeight: function gisAddWeight(_ref6, objadd) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["f" /* GIS_ADD_WEIGHT */], objadd);
  },
  saveCarboFoodBefore: function saveCarboFoodBefore(_ref7, plan) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* SAVE_CARBO_FOOD_BEFORE */], plan);
  },
  deleteCarboFoodBefore: function deleteCarboFoodBefore(_ref8, plan) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["h" /* DELETE_CARBO_FOOD_BEFORE */], plan);
  },
  carbobeforeAddWeight: function carbobeforeAddWeight(_ref9, objadd) {
    var commit = _ref9.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["i" /* CARBOBEFORE_ADD_WEIGHT */], objadd);
  },
  saveCarboFoodAfter: function saveCarboFoodAfter(_ref10, plan) {
    var commit = _ref10.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["j" /* SAVE_CARBO_FOOD_AFTER */], plan);
  },
  deleteCarboFoodAfter: function deleteCarboFoodAfter(_ref11, plan) {
    var commit = _ref11.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["k" /* DELETE_CARBO_FOOD_AFTER */], plan);
  },
  carboafterAddWeight: function carboafterAddWeight(_ref12, objadd) {
    var commit = _ref12.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["l" /* CARBOAFTER_ADD_WEIGHT */], objadd);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(21);


var _types$SAVE_PHFOOD$ty;



/* harmony default export */ __webpack_exports__["a"] = (_types$SAVE_PHFOOD$ty = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_PHFOOD$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SAVE_PHFOOD */], function (state, plan) {
  state.phfoodlist.push(plan);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_PHFOOD$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* DELETE_PHFOOD */], function (state, idx) {
  state.phfoodlist.splice(idx, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_PHFOOD$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* PH_ADD_WEIGHT */], function (state, objadd) {
  state.phfoodlist[objadd.obj_index].foodWeight += objadd.obj_weight;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_PHFOOD$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SAVE_GIS_FOOD */], function (state, plan) {
  state.gisfoodlist.push(plan);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_PHFOOD$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* DELETE_GIS_FOOD */], function (state, idx) {
  state.gisfoodlist.splice(idx, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_PHFOOD$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* GIS_ADD_WEIGHT */], function (state, objadd) {
  state.gisfoodlist[objadd.obj_index].foodWeight += objadd.obj_weight;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_PHFOOD$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* SAVE_CARBO_FOOD_BEFORE */], function (state, plan) {
  state.carbofoodlist1.push(plan);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_PHFOOD$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* DELETE_CARBO_FOOD_BEFORE */], function (state, idx) {
  state.carbofoodlist1.splice(idx, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_PHFOOD$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* CARBOBEFORE_ADD_WEIGHT */], function (state, objadd) {
  state.carbofoodlist1[objadd.obj_index].foodWeight += objadd.obj_weight;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_PHFOOD$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SAVE_CARBO_FOOD_AFTER */], function (state, plan) {
  state.carbofoodlist2.push(plan);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_PHFOOD$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* DELETE_CARBO_FOOD_AFTER */], function (state, idx) {
  state.carbofoodlist2.splice(idx, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_PHFOOD$ty, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* CARBOAFTER_ADD_WEIGHT */], function (state, objadd) {
  state.carbofoodlist2[objadd.obj_index].foodWeight += objadd.obj_weight;
}), _types$SAVE_PHFOOD$ty);

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhushe.202a493.png";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(145),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(143),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(148),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(136),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(146),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(152),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(114)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(154),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e8caf9c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(140),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(149),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(151),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(137),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(113)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(142),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34420565",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "result-wrap nocount text-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "result-text"
  }, [_vm._v("餐前需注射胰岛素")]), _vm._v(" "), _c('div', {
    staticClass: "result-time wcar"
  }, [(_vm.unit) ? _c('div', {
    staticClass: "times"
  }, [_c('span', [_vm._v(_vm._s(_vm.unit))]), _vm._v("单位")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.gohome()
      }
    }
  }, [_vm._v("返回首页")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-thumb"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(117)
    }
  })])
}]}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imgUrl),
      expression: "imgUrl"
    }],
    staticClass: "topbanner"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "calculate-link",
    attrs: {
      "to": "/chosefood"
    }
  }, [_vm._v("开始计算摄入热量")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "tip-icon"
  }, [_vm._v("使用帮助")]), _vm._v(" "), _c('ul', {
    staticClass: "tip-detail"
  }, [_c('li', [_vm._v("1. 请选择所吃食物")]), _vm._v(" "), _c('li', [_vm._v("2. 所有食物需先选择食物类别")]), _vm._v(" "), _c('li', [_vm._v("3. 所吃食物可以选择多项")]), _vm._v(" "), _c('li', [_vm._v("4. 计算出所有食物产生的总热量")]), _vm._v(" "), _c('li', [_vm._v("5. 计算某一种运动方式所需时间")])])])
}]}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": "true",
      "useIcon": "true"
    }
  }), _vm._v(" "), (!_vm.foodschosed.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "empty-text text-center"
  }, [_vm._v("请选择所吃食物")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        _vm.poppicker()
      }
    }
  }, [_c('span', {
    staticClass: "iconplus"
  }, [_vm._v("添加食物")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "name"
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.foodschosed.length) ? _c('div', {
    staticClass: "foods-box"
  }, [_c('ul', {
    staticClass: "foods-wrap"
  }, _vm._l((_vm.foodschosed), function(foodselected, idx) {
    return _c('li', [(foodselected.foodThumb) ? _c('span', {
      staticClass: "food-icon",
      style: ({
        backgroundImage: 'url(' + foodselected.foodThumb + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "food-title ellipsis"
    }, [_vm._v(_vm._s(foodselected.foodTitle))]), _vm._v(" "), _c('div', {
      staticClass: "food-kilo"
    }), _vm._v(" "), _c('span', {
      staticClass: "icon-del",
      on: {
        "click": function($event) {
          _vm.delfood(idx)
        }
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        _vm.poppicker()
      }
    }
  }, [_c('span', {
    staticClass: "iconplus"
  }, [_vm._v("添加食物")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.calculate()
      }
    }
  }, [_vm._v("查看食物血糖生成指数")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bgfoods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": "true",
      "useIcon": "true"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "zoomIn"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "poper"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('i', {
    on: {
      "click": function($event) {
        _vm.hidepop()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("请输入餐前血糖值")]), _vm._v(" "), _c('div', {
    staticClass: "input_tip"
  }, [_vm._v("有效值介于4.4~25")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "typevalue"
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.savedata()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), (_vm.show_error) ? _c('div', {
    staticClass: "error_info"
  }, [_vm._v("请输入有效值")]) : _vm._e()])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "zoomIn"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show1),
      expression: "show1"
    }],
    staticClass: "poper"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('i', {
    on: {
      "click": function($event) {
        _vm.hidepop1()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("请输入餐后目标值")]), _vm._v(" "), _c('div', {
    staticClass: "input_tip"
  }, [_vm._v("有效值介于4.4~15")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "typevalue1"
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.savedata1()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), (_vm.show_error1) ? _c('div', {
    staticClass: "error_info"
  }, [_vm._v("请输入有效值")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "count-wrap bluestyle"
  }, [_c('div', {
    staticClass: "count-inner"
  }, [_c('div', {
    staticClass: "count-text"
  }, [_vm._v("碳水化合物")]), _vm._v(" "), _c('countTo', {
    staticClass: "count-num",
    attrs: {
      "separator": _vm.theseparator,
      "startVal": _vm.startVal,
      "endVal": _vm.endVal,
      "duration": 2000
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count-text"
  }, [_vm._v("克")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chose-wrap"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.showpop()
      }
    }
  }, [_c('div', {
    staticClass: "icon-canqian"
  }, [_vm._v("餐前血糖值")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.data_canqian))])])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showpop1()
      }
    }
  }, [_c('div', {
    staticClass: "icon-canhou"
  }, [_vm._v("餐后目标值")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right motion"
  }, [_vm._v("\r\n\t\t\t\t\t" + _vm._s(_vm.data_canhou) + "\r\n\t\t\t\t")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.selectInsulin()
      }
    }
  }, [_c('div', {
    staticClass: "icon-total"
  }, [_vm._v("一日胰岛素总用量")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.data_total))])])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.selectType()
      }
    }
  }, [_c('div', {
    staticClass: "icon-zhushe"
  }, [_vm._v("使用胰岛素类别")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right"
  }, [_vm._v("\r\n\t\t\t\t\t" + _vm._s(_vm.data_zhushe) + "\r\n\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.goresult()
      }
    }
  }, [_vm._v("计算餐前注射胰岛素")])], 1)
},staticRenderFns: []}

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imgUrl),
      expression: "imgUrl"
    }],
    staticClass: "topbanner"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "calculate-link",
    attrs: {
      "to": "/fillform"
    }
  }, [_vm._v("开始计算一日所需能量")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "tip-icon"
  }, [_vm._v("使用帮助")]), _vm._v(" "), _c('ul', {
    staticClass: "tip-detail"
  }, [_c('li', [_vm._v("1. 请选择所吃食物")]), _vm._v(" "), _c('li', [_vm._v("2. 所有食物需先选择食物类别")]), _vm._v(" "), _c('li', [_vm._v("3. 所吃食物可以选择多项")]), _vm._v(" "), _c('li', [_vm._v("4. 计算出所有食物产生的总热量")]), _vm._v(" "), _c('li', [_vm._v("5. 计算某一种运动方式所需时间")])])])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "count-wrap"
  }, [_c('div', {
    staticClass: "count-inner"
  }, [_c('div', {
    staticClass: "count-text"
  }, [_vm._v("运动消耗热量")]), _vm._v(" "), _c('countTo', {
    staticClass: "count-num",
    attrs: {
      "separator": _vm.theseparator,
      "startVal": _vm.startVal,
      "endVal": _vm.endVal,
      "duration": 2000
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count-text"
  }, [_vm._v("卡路里")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "result-wrap text-center"
  }, [_c('div', {
    staticClass: "result-thumb"
  }, [(_vm.cover) ? _c('img', {
    attrs: {
      "src": _vm.cover
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "result-text"
  }, [_vm._v("至少需运动时长")]), _vm._v(" "), _c('div', {
    staticClass: "result-time"
  }, [(_vm.hour) ? _c('div', {
    staticClass: "times"
  }, [_c('span', [_vm._v(_vm._s(_vm.hour))]), _vm._v("小时")]) : _vm._e(), _vm._v(" "), (_vm.min) ? _c('div', {
    staticClass: "times"
  }, [_c('span', [_vm._v(_vm._s(_vm.min))]), _vm._v("分钟")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.gohome()
      }
    }
  }, [_vm._v("返回首页")])])
},staticRenderFns: []}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": "true",
      "useIcon": "true"
    }
  }), _vm._v(" "), (!_vm.foodschosed.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "empty-text text-center"
  }, [_vm._v("请选择所吃食物")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        _vm.poppicker()
      }
    }
  }, [_c('span', {
    staticClass: "iconplus"
  }, [_vm._v("添加食物")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "name"
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.foodschosed.length) ? _c('div', {
    staticClass: "foods-box"
  }, [_c('ul', {
    staticClass: "foods-wrap"
  }, _vm._l((_vm.foodschosed), function(foodselected, idx) {
    return _c('li', [(foodselected.foodThumb) ? _c('span', {
      staticClass: "food-icon",
      style: ({
        backgroundImage: 'url(' + foodselected.foodThumb + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "food-title"
    }, [_vm._v(_vm._s(foodselected.foodTitle))]), _vm._v(" "), _c('div', {
      staticClass: "food-kilo"
    }, [_vm._v(_vm._s(foodselected.foodWeight) + "g")]), _vm._v(" "), _c('span', {
      staticClass: "icon-del",
      on: {
        "click": function($event) {
          _vm.delfood(idx)
        }
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        _vm.poppicker()
      }
    }
  }, [_c('span', {
    staticClass: "iconplus"
  }, [_vm._v("添加食物")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.calculate()
      }
    }
  }, [_vm._v("计算热量")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bgfoods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": "true",
      "useIcon": "true"
    }
  }), _vm._v(" "), (!_vm.foodschosed.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "empty-text text-center"
  }, [_vm._v("请选择所吃食物")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        _vm.poppicker()
      }
    }
  }, [_c('span', {
    staticClass: "iconplus"
  }, [_vm._v("添加食物")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "name"
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.foodschosed.length) ? _c('div', {
    staticClass: "foods-box"
  }, [_c('ul', {
    staticClass: "foods-wrap"
  }, _vm._l((_vm.foodschosed), function(foodselected, idx) {
    return _c('li', [(foodselected.foodThumb) ? _c('span', {
      staticClass: "food-icon",
      style: ({
        backgroundImage: 'url(' + foodselected.foodThumb + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "food-title"
    }, [_vm._v(_vm._s(foodselected.foodTitle))]), _vm._v(" "), _c('div', {
      staticClass: "food-kilo"
    }, [_vm._v(_vm._s(foodselected.foodWeight) + "g")]), _vm._v(" "), _c('span', {
      staticClass: "icon-del",
      on: {
        "click": function($event) {
          _vm.delfood(idx)
        }
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        _vm.poppicker()
      }
    }
  }, [_c('span', {
    staticClass: "iconplus"
  }, [_vm._v("添加食物")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.calculate()
      }
    }
  }, [_vm._v("计算碳水化合物")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bgfoods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])
}]}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imgUrl),
      expression: "imgUrl"
    }],
    staticClass: "topbanner"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "calculate-link",
    attrs: {
      "to": "/sugarfood"
    }
  }, [_vm._v("开始计算血糖指数")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "tip-icon"
  }, [_vm._v("使用帮助")]), _vm._v(" "), _c('ul', {
    staticClass: "tip-detail"
  }, [_c('li', [_vm._v("1. 请选择所吃食物")]), _vm._v(" "), _c('li', [_vm._v("2. 所有食物需先选择食物类别")]), _vm._v(" "), _c('li', [_vm._v("3. 所吃食物可以选择多项")]), _vm._v(" "), _c('li', [_vm._v("4. 计算出所有食物产生的总热量")]), _vm._v(" "), _c('li', [_vm._v("5. 计算某一种运动方式所需时间")])])])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.swiperSlides.length > 0) ? _c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.swiperSlides), function(slide) {
    return _c('swiper-slide', {
      key: slide.index
    }, [_c('div', {
      staticClass: "count-wrap ",
      class: {
        greenstyle: slide.foodUseable < 55, bluestyle: slide.foodUseable >= 55 && slide.foodUseable <= 70
      }
    }, [_c('div', {
      staticClass: "count-inner"
    }, [_c('div', {
      staticClass: "count-text"
    }, [_vm._v("血糖指数")]), _vm._v(" "), _c('div', {
      staticClass: "count-num"
    }, [_c('span', {
      class: {
        hightip: slide.foodUseable > 70
      }
    }, [_vm._v(_vm._s(slide.foodUseable))])])])]), _vm._v(" "), _c('div', {
      staticClass: "result-wrap text-center"
    }, [_c('div', {
      staticClass: "gis-title ellipsis"
    }, [_vm._v(_vm._s(slide.foodTitle))]), _vm._v(" "), (slide.foodThumb) ? _c('div', {
      staticClass: "result-thumb gis-thumb"
    }, [_c('img', {
      attrs: {
        "src": slide.foodThumb
      }
    })]) : _vm._e(), _vm._v(" "), (slide.foodUseable > 70) ? _c('div', {
      staticClass: "result-time gis-resultip"
    }, [_vm._v("\r\n\t\t\t\t\t属于高血糖生成指数食物，建议少吃\r\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (slide.foodUseable < 55) ? _c('div', {
      staticClass: "result-time gis-resultip"
    }, [_vm._v("\r\n\t\t\t\t\t属于低血糖生成指数食物，建议多吃\r\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (slide.foodUseable >= 55 && slide.foodUseable <= 70) ? _c('div', {
      staticClass: "result-time gis-resultip"
    }, [_vm._v("\r\n\t\t\t\t\t属于中等血糖生成指数食物，建议适量食用\r\n\t\t\t\t")]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.gohome()
      }
    }
  }, [_vm._v("返回首页")])], 1)
},staticRenderFns: []}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "count-wrap greenstyle"
  }, [_c('div', {
    staticClass: "count-inner"
  }, [_c('div', {
    staticClass: "count-text"
  }, [_vm._v("一日所需能量")]), _vm._v(" "), _c('countTo', {
    staticClass: "count-num",
    attrs: {
      "separator": _vm.theseparator,
      "startVal": _vm.startVal,
      "endVal": _vm.endVal,
      "duration": 2000
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count-text"
  }, [_vm._v("千卡")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dayneed-result"
  }, [_c('div', {
    staticClass: "result-text text-center"
  }, [_vm._v("各餐配比")]), _vm._v(" "), _c('div', {
    staticClass: "bili-wrap"
  }, [_c('div', {
    staticClass: "bili-block bili-a"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "bili-item bili1"
  }, [_c('span', [_vm._v(_vm._s(_vm.a * 2))]), _vm._v("千卡\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "bili-item bili2"
  }, [_c('span', [_vm._v(_vm._s(_vm.a * 2))]), _vm._v("千卡\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "bili-item bili3"
  }, [_c('span', [_vm._v(_vm._s(_vm.a))]), _vm._v("千卡\r\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "bili-info"
  }, [_vm._v("餐比A")])]), _vm._v(" "), _c('div', {
    staticClass: "bili-block bili-b"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "bili-item bili1"
  }, [_c('span', [_vm._v(_vm._s(_vm.b))]), _vm._v("千卡\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "bili-item bili2"
  }, [_c('span', [_vm._v(_vm._s(_vm.b))]), _vm._v("千卡\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "bili-item bili3"
  }, [_c('span', [_vm._v(_vm._s(_vm.b))]), _vm._v("千卡\r\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "bili-info"
  }, [_vm._v("餐比B")])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "calculate-link",
    attrs: {
      "to": "/dayneedindex"
    }
  }, [_vm._v("返回首页")])], 1)
},staticRenderFns: []}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imgUrl),
      expression: "imgUrl"
    }],
    staticClass: "topbanner"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "calculate-link clearfix"
  }, [_c('div', {
    staticClass: "half fl"
  }, [_c('router-link', {
    attrs: {
      "to": "/carbofood"
    }
  }, [_vm._v("补打胰岛素")])], 1), _vm._v(" "), _c('div', {
    staticClass: "half fr"
  }, [_c('router-link', {
    attrs: {
      "to": "/carbofood1"
    }
  }, [_vm._v("餐前注射胰岛素")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "tip-icon"
  }, [_vm._v("使用帮助")]), _vm._v(" "), _c('ul', {
    staticClass: "tip-detail"
  }, [_c('li', [_vm._v("1. 请选择所吃食物")]), _vm._v(" "), _c('li', [_vm._v("2. 所有食物需先选择食物类别")]), _vm._v(" "), _c('li', [_vm._v("3. 所吃食物可以选择多项")]), _vm._v(" "), _c('li', [_vm._v("4. 计算出所有食物产生的总热量")]), _vm._v(" "), _c('li', [_vm._v("5. 计算某一种运动方式所需时间")])])])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": "true",
      "useIcon": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count-wrap"
  }, [_c('div', {
    staticClass: "count-inner"
  }, [_c('div', {
    staticClass: "count-text"
  }, [_vm._v("摄入总热量")]), _vm._v(" "), _c('countTo', {
    staticClass: "count-num",
    attrs: {
      "separator": _vm.theseparator,
      "startVal": _vm.startVal,
      "endVal": _vm.endVal,
      "duration": 2000
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count-text"
  }, [_vm._v("卡路里")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chose-wrap"
  }, [_c('h3', [_vm._v("请选择体重与运动")]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.selectWeight()
      }
    }
  }, [_c('div', {
    staticClass: "icon-weight"
  }, [_vm._v("您的体重")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right"
  }, [(_vm.defaultWeight) ? _c('span', [_vm._v(_vm._s(_vm.defaultWeight) + "kg")]) : _vm._e()])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.selectMotion()
      }
    }
  }, [_c('div', {
    staticClass: "icon-motion"
  }, [_vm._v("选择运动")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right motion"
  }, [_vm._v(_vm._s(_vm.defaultMotion))])])])]), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.goresult()
      }
    }
  }, [_vm._v("计算运动方案时长")])], 1)
},staticRenderFns: []}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": "true",
      "useIcon": "true"
    }
  }), _vm._v(" "), (!_vm.foodschosed.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "empty-text text-center"
  }, [_vm._v("请选择所吃食物")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        _vm.poppicker()
      }
    }
  }, [_c('span', {
    staticClass: "iconplus"
  }, [_vm._v("添加食物")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "name"
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.foodschosed.length) ? _c('div', {
    staticClass: "foods-box"
  }, [_c('ul', {
    staticClass: "foods-wrap"
  }, _vm._l((_vm.foodschosed), function(foodselected, idx) {
    return _c('li', [(foodselected.foodThumb) ? _c('span', {
      staticClass: "food-icon",
      style: ({
        backgroundImage: 'url(' + foodselected.foodThumb + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "food-title"
    }, [_vm._v(_vm._s(foodselected.foodTitle))]), _vm._v(" "), _c('div', {
      staticClass: "food-kilo"
    }, [_vm._v(_vm._s(foodselected.foodWeight) + "g")]), _vm._v(" "), _c('span', {
      staticClass: "icon-del",
      on: {
        "click": function($event) {
          _vm.delfood(idx)
        }
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        _vm.poppicker()
      }
    }
  }, [_c('span', {
    staticClass: "iconplus"
  }, [_vm._v("添加食物")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.calculate()
      }
    }
  }, [_vm._v("计算碳水化合物")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bgfoods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])
}]}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": "true",
      "useIcon": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chose-wrap unfixed"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.selectHeight()
      }
    }
  }, [_c('div', {
    staticClass: "icon-height"
  }, [_vm._v("您的身高")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right"
  }, [(_vm.defaultHeight) ? _c('span', [_vm._v(_vm._s(_vm.defaultHeight) + "CM")]) : _vm._e()])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.selectWeight()
      }
    }
  }, [_c('div', {
    staticClass: "icon-weight"
  }, [_vm._v("您的体重")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right"
  }, [(_vm.defaultWeight) ? _c('span', [_vm._v(_vm._s(_vm.defaultWeight) + "kg")]) : _vm._e()])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.selectMotion()
      }
    }
  }, [_c('div', {
    staticClass: "icon-motion"
  }, [_vm._v("活动强度")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right motion"
  }, [_vm._v(_vm._s(_vm.defaultMotion))])])])]), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.goresult()
      }
    }
  }, [_vm._v("计算能量")])], 1)
},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "count-wrap bluestyle"
  }, [_c('div', {
    staticClass: "count-inner"
  }, [_c('div', {
    staticClass: "count-text"
  }, [_vm._v("碳水化合物")]), _vm._v(" "), _c('countTo', {
    staticClass: "count-num",
    attrs: {
      "separator": _vm.theseparator,
      "startVal": _vm.startVal,
      "endVal": _vm.endVal,
      "duration": 2000
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count-text"
  }, [_vm._v("克")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "result-wrap text-center"
  }, [_c('div', {
    staticClass: "result-thumb"
  }, [_c('img', {
    attrs: {
      "src": _vm.cover
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "result-text"
  }, [_vm._v("需补打胰岛素")]), _vm._v(" "), _c('div', {
    staticClass: "result-time wcar"
  }, [(_vm.unit) ? _c('div', {
    staticClass: "times"
  }, [_c('span', [_vm._v(_vm._s(_vm.unit))]), _vm._v("单位")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.gohome()
      }
    }
  }, [_vm._v("返回首页")])])
},staticRenderFns: []}

/***/ })
],[74]);


// WEBPACK FOOTER //
// static/js/app.56bb4d7499b854ace982.js